module.exports = __webpack_public_path__ + "img/icons-16-reorder.3ec1c8f1.svg";